<template>

  <b-container fluid class="color-transition">
      <b-row>
        <b-col style="padding:0">
          <router-link @click="Fn()" style="text-decoration:none;" to="/AS_About">
            <b-button block squared variant="transparent" class="bottomFixedNavColor">
              <span class="ml-2" ><b-icon icon="building" variant=""></b-icon> আমাৰ বিষয়ে </span>
            </b-button>
          </router-link>
        </b-col>
        <b-col style="padding:0">
          <router-link style="text-decoration:none;" to="/AS_AllDocuments">
            <b-button block squared variant="transparent" class="bottomFixedNavColor">
              <span class="ml-2"><b-icon icon="file-earmark-text" variant=""></b-icon> নথিসমূহ  </span>
            </b-button>
          </router-link>
        </b-col>
        <b-col style="padding:0">
          <router-link style="text-decoration:none;" to="/AS_Gallery">
            <b-button block squared variant="transparent" class="bottomFixedNavColor" >
              <span><b-icon icon="image" variant=""></b-icon> গেলেৰী </span>
            </b-button>
          </router-link>
        </b-col>
        <b-col style="padding:0">
        <router-link style="text-decoration:none;" to="/AS_RTI">
          <b-button block squared variant="transparent" class="bottomFixedNavColor" >
          <span><b-icon icon="pencil-square" variant=""></b-icon> তথ্যৰ অধিকাৰ </span>
         </b-button>
       </router-link>
        </b-col>
        <b-col style="padding:0">
          <router-link style="text-decoration:none;" to="/AS_Career">
          <b-button block squared variant="transparent" class="bottomFixedNavColor" >
          <span><b-icon icon="people" variant=""></b-icon> নিযুক্তি </span>
        </b-button>
      </router-link>
        </b-col>
        <b-col style="padding:0">
          <router-link style="text-decoration:none;" to="/AS_FAQ">
            <b-button block squared variant="transparent"  class="bottomFixedNavColor" >
              <span><b-icon icon="question-diamond" variant=""></b-icon> সততে উত্থাপিত প্ৰশ্নসমূহ </span>
            </b-button>
          </router-link>
        </b-col>
      </b-row>
    </b-container>

</template>
<script>
export default{
methods: {
  Fn(){
  alert('hello');
}
}
}
</script>
<style scoped="true">

  .color-transition{
    background-image: linear-gradient(to right, #00838f , #4dd0e1 , #00838f );

  }
  .bottomFixedNavColor{
   color:#ffff;
    transition: 0.2s;
    height: 75px;
    padding-right: 0px !important;
    padding-left: 0px !important;
    background-color: #0288d1;

  }
  .bottomFixedNavColor:hover{
    background-color:  #0277bd  ;
    color:#ffeb3b;
    font-size: 1.1rem;
  }

</style>
